import Vue from 'vue';

/**
 * 此marco提供一个固定的序列渲染,包括表头和序号
 * 可以选择特定的文本作为表头
 */
interface opt {
    name: string
}

export function macroAutoIndex(vm: Vue, h: any) {
    const scopedSlots = {
        default: function (body) {
            const desc = body.desc;

            return <span>{body.$index + 1}</span>
        },
        header: function (header) {
            return <span>{header.desc.name || '#'}</span>
        }
    }

    return <colDefiner {...{ scopedSlots }}></colDefiner>;
}